<template>
  <section>
    <div class="container">
      <div class="col-3">
        <div v-if="loading" class="content content-centered">
          <pulse-loader></pulse-loader>
        </div>
        <div v-else>
          <div class="row">
            <div class="flash-message" v-if="flash">
              <div class="alert" :class="'alert-' + flashType">
                {{ flashMessage }}
              </div>
            </div>
          </div>

          <div id="resetDetails" class="row">
            <vue-form :state="formstate" class="ui form loginForm row " @submit.prevent="resetPassword">

              <h2 class="heading">Reset Password</h2>
              <div class="col-sm-12">
                <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.password)">
                  <label>New Password</label>
                  <input class="form-control" id="password" name="password" required placeholder="New Password"
                    type="password" v-model="password"
                    pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$#!%*?&]{8,}$" />
                  <field-messages name="password" show="$touched || $submitted" class="form-control-feedback">
                    <div slot="required">New Password is a required field</div>
                    <div slot="pattern">Password should have at least one uppercase letter, one lowercase letter, one number and one special character. ( eg: Xyz@1234 )</div>
                  </field-messages>
                </validate>
              </div>
              <div class="col-sm-12">
                <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.passwordVerify)">
                  <label>Confirm Password</label>
                  <input class="form-control" id="passwordVerify" name="passwordVerify" required
                    placeholder="Confirm Password" type="password" v-model="passwordVerify"
                    pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!#%*?&])[A-Za-z\d@$!%#*?&]{8,}$" />
                  <field-messages name="passwordVerify" show="$touched || $submitted" class="form-control-feedback">
                    <div slot="required">Confirm Password is a required field</div>
                    <div slot="pattern">Password should have at least one uppercase letter, one lowercase letter, one number and one special character. ( eg: Xyz@1234 )</div>
                  </field-messages>
                </validate>
              </div>
              <div class="col-sm-12 showpass_cls">
                <input type="checkbox" v-on:click="showPassword"><span>Show Password</span>
              </div>
              <div class="form-actions">
                <button type="submit" class="mr-2 btn gradientbt" :disabled="!(formstate.$dirty && formstate.$valid)" v-if="$route.params && !$route.params._id">
                  Reset Password
                </button>
              </div>
            </vue-form>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { authService, formService } from '../../../services';

import config from '../../../config';

export default {
  name: 'ResetPassword',
  data() {
    return {
      loading: false,
      password: "",
      passwordVerify: "",
      formstate: {},
      flash: false,
      flashType: null,
      flashMessage: '',
    };
  },

  methods: {
    fieldClassName: formService.fieldClassName,

    showPassword() {
      var x = document.getElementById("password");
      var y = document.getElementById("passwordVerify")
      if (x.type === "password" && y.type === "password") {
        x.type = "text";
        y.type = "text";
      } else {
        x.type = "password";
        y.type = "password";
      }
    },

    resetPassword() {
      if (this.password !== this.passwordVerify) {
        this.loading = true
        this.$snotify.error(`New Password and Confirm Password must be Same`);
        return;
      }
      this.loading = true
      const token = this.$route.query.token;
      authService.resetPasswords(this.password, token)
        .then((response) => {          
          this.loading = false
          // window.location.href = "/login";   
          this.$router.push("/login");
          this.$snotify.success(`Password has been reset successfully`);          
          this.password= "";
          this.passwordVerify= "";
        })
        .catch(error => {
          // window.location.href = "/login";   
          this.$router.push("/forgot-pass-callback");
          this.password= "";
          this.passwordVerify= "";
          this.loading = false;
          if (error) {
            this.$snotify.error(`Password has been reset failed`);
          }
        })
    }
  },
};
</script>

<style>
.heading {
  margin-left: 120px;
  margin-bottom: 20px;
}

.container {
  height: 100vh;
  background: white;
  width: 100%;
}

.col-3 {
  display: grid;
  margin-top: 10%;
  margin-left: 30%;
  justify-content: center;
}
.loginForm .form-actions button:hover{
  color: #fff !important;
}
</style>


// WEBPACK FOOTER //
// ResetPassword.vue?3b3eabd9